import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { NavLink } from "react-router-dom";
import { HOME_SEARCH_USER, HOMEPAGE } from "../../../navigation/Constants";
import ProfileItem from "../../Home/components/ProfileItem";
import EmptyCarpetPlaceHolder from "../../../components/EmptyCarpetPlaceHolder";
import EmptyCarpetResult from "../../../components/EmptyCarpetResult";

const SearchCarpet = () => {
  const dispatch = useDispatch();

  const { searchResults } = useSelector(
    (state: RootState) => state.searchUsers
  );

  useEffect(() => {
    console.log("SearchCarpet searchResults:", searchResults);
  }, [searchResults]);

  return (
    <>
      {/* <div className="top_sec wf-section"> */}
      <div className="top_sec desk">
        <NavLink className="top_logo_bounakir w-inline-block" to={HOMEPAGE}>
          <img
            src="assets/images/shoshke_logo.svg"
            loading="lazy"
            alt="shoshke logo"
          />
        </NavLink>
        {/* <div className="top_content messages w-clearfix"> */}
        <div className="top_content w-clearfix">
          <NavLink
            className="top_back search_res w-inline-block"
            to={HOME_SEARCH_USER}
          >
            <img src="assets/images/ic_back_white.svg" loading="lazy" alt="" />
          </NavLink>

          <div className="top_title_nav profile w-clearfix">
            <h1 className="top_title">תוצאות חיפוש</h1>
          </div>
          {/* <h1
            className="top_title messages"
            // style={{ position: "relative", left: "52px" }}
          >
            תוצאות חיפוש
          </h1> */}
        </div>
      </div>
      <div className="content_sec desk wf-section">
        {searchResults.length ? (
          <ul className="gallery_list prof w-list-unstyled">
            {searchResults.map((member, index) => {
              return <ProfileItem key={member.memberCode} member={member} />;
            })}
          </ul>
        ) : (
          <EmptyCarpetResult
            imgSrc="/assets/images/no_pict.png"
            title="לא מצאנו אנשים התואמים לחיפוש שלך"
            subTitle="אפשר לנסות לשנות את החיפוש"
          />
        )}

        {/* <EmptyCarpetResult
          imgSrc="/assets/images/no_pict.png"
          title="לא מצאנו אנשים התואמים לחיפוש שלך"
          subTitle="אפשר לנסות לשנות את החיפוש"
        /> */}

        {/* <ul className="gallery_list prof w-list-unstyled">
          {searchResults.map((member, index) => {
            return <ProfileItem key={member.memberCode} member={member} />;
          })}
        </ul> */}
      </div>
    </>
  );
};

export default SearchCarpet;
